import style from './style.module.scss'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { getBannerState } from 'store/selectors'
import Routes from 'components/App/Routes'
import Header from 'components/Header'
import NotificationBanner from 'components/NotificationBanner'
import { Toaster } from 'react-hot-toast'
import { useAuth } from 'components/Auth'
import {
  ApplicationItemStatus,
  useAffiliateApplication,
} from 'hooks/useAffiliateAplication'
import { useAffiliate } from 'hooks/useAffiliate'
import { useSettings } from 'components/Settings'
import { useMyActiveSubscriptions } from 'hooks/subscriptions'
import { useProductAccess } from 'hooks/useProductAccess'
import { useEffect } from 'react'
import {
  SubscriptionPackageType,
  SubscriptionStatus,
} from 'services/programming'
import {
  updateShowBanner,
  updateBannerMessage,
  updateBannerButton,
  updateBannerType,
} from 'store/slices/banner'

function App() {
  const bannerState = useSelector(getBannerState)
  const { user } = useAuth()
  const { selectedAffiliate: affiliate } = useAffiliate()
  const applicationStatusQuery = useAffiliateApplication()
  const settings = useSettings((s) => s.data)
  const subscriptions = useMyActiveSubscriptions()
  const productAccess = useProductAccess()
  const dispatch = useDispatch()

  useEffect(() => {
    if (user && (window.needsToIdentify || window.needsToIdentify == null)) {
      analytics.identify(`${user.id}`, {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        affiliateRole:
          affiliate?.roles?.length > 0 ? affiliate?.roles[0] : null,
      })

      window.needsToIdentify = false
    }
  }, [user])

  useEffect(() => {
    if (user && affiliate) {
      analytics.identify(`${user.id}`, {
        affiliateRole:
          affiliate?.roles?.length > 0 ? affiliate?.roles[0] : null,
      })
    }
  }, [affiliate])

  useEffect(() => {
    if (subscriptions && applicationStatusQuery.isSuccess) {
      const askSubscription = subscriptions.find(
        (s) =>
          s.package.name === SubscriptionPackageType.ATK_STARTER &&
          new Date() <= new Date(s.expiryDate),
      )
      let bannerText = ''
      let ctaText = ''
      let ctaUrl = ''
      let showBanner = false
      let bannerType = ''

      const subscriptionExpirationInDays = Math.floor(
        (new Date(askSubscription?.expiryDate).getTime() -
          new Date().getTime()) /
          (1000 * 60 * 60 * 24),
      )

      if (askSubscription?.status === SubscriptionStatus.active) {
        if (
          applicationStatusQuery &&
          applicationStatusQuery.data.application.status ===
            ApplicationItemStatus.DEFAULT
        ) {
          showBanner = true
          bannerText = settings.bannerMessages.askNotApplied.text
          ctaText = settings.bannerMessages.askNotApplied.cta.text
          ctaUrl = settings.bannerMessages.askNotApplied.cta.url
          bannerType = 'info'
        }

        if (
          applicationStatusQuery &&
          applicationStatusQuery.data.application.status !==
            ApplicationItemStatus.DEFAULT
        ) {
          showBanner = true
          bannerText = settings.bannerMessages.askReviewApplication.text
          ctaText = settings.bannerMessages.askReviewApplication.cta.text
          ctaUrl = settings.bannerMessages.askReviewApplication.cta.url
          bannerType = 'info'
        }
      }

      if (subscriptionExpirationInDays <= 30) {
        showBanner = true

        if (
          applicationStatusQuery.data.application.status ===
          ApplicationItemStatus.DEFAULT
        ) {
          bannerText = settings.bannerMessages.starterKitExpiry.text.replace(
            '[X]',
            subscriptionExpirationInDays === 1
              ? '1 day'
              : `${subscriptionExpirationInDays} days`,
          )
          ctaText = settings.bannerMessages.starterKitExpiry.cta.text
          ctaUrl = settings.bannerMessages.starterKitExpiry.cta.url
          bannerType = settings.bannerMessages.starterKitExpiry.bannerType
        } else {
          bannerText =
            settings.bannerMessages.askAppliedAccessExpiring.text.replace(
              '[X]',
              subscriptionExpirationInDays === 1
                ? '1 day'
                : `${subscriptionExpirationInDays} days`,
            )
          ctaText = settings.bannerMessages.askAppliedAccessExpiring.cta.text
          ctaUrl = settings.bannerMessages.askAppliedAccessExpiring.cta.url
          bannerType =
            settings.bannerMessages.askAppliedAccessExpiring.bannerType
        }
      }

      dispatch(updateShowBanner(showBanner))
      dispatch(updateBannerMessage(bannerText))
      dispatch(updateBannerButton({ text: ctaText, url: ctaUrl }))
      dispatch(updateBannerType(bannerType))
    }
  }, [subscriptions, applicationStatusQuery])

  return (
    <div className={style.wrapper}>
      <NotificationBanner
        className={classNames(style.banner, {
          [style.hideBanner]: !bannerState.showBanner,
        })}
      />
      <Header />
      <Routes />
      <Toaster />
    </div>
  )
}

export default App
